import { APP_CONSTS } from 'core/constants/app-consts';
import moment from 'moment';
import { UserConfiguration } from 'core/entities/user/user-configuration';
import { PlacerEntityModel } from '@placer-ui/types';
import { getFeatureFlags } from 'core/flow-control';
import { UserPermissions } from 'core/entities/user/user-permissions';
import { MIN_ANALYTICS_DATE } from 'core/constants/configuration';
import { PoiDate } from 'features/insights/types/dates-types';

export const buildDates = (
    entities: PlacerEntityModel<any>[],
    configuration?: UserConfiguration,
    permissions?: UserPermissions,
    platformDates?: { dates: { [p: string]: PoiDate } },
) => {
    const minDateMonth = moment(
        configuration?.analytics_min_date || MIN_ANALYTICS_DATE,
        'YYYY-MM-DD',
    );
    let maxDataDate = moment(
        configuration?.dashboard_max_date || configuration?.analytics_max_date,
        'YYYY-MM-DD',
    );
    let maxDataMonth = moment(
        configuration?.dashboard_max_month || configuration?.analytics_max_month,
    );
    if (
        getFeatureFlags().enable_max_billboard_date_ux_ff &&
        configuration?.billboard_max_date &&
        entities.some((entity) => entity.originalEntity.type === 'billboard')
    ) {
        maxDataDate = moment(configuration.billboard_max_date, 'YYYY-MM-DD');
        maxDataMonth = moment(configuration.billboard_max_date).subtract(1, 'months');
    } else if (permissions?.show_qa_features) {
        maxDataDate = moment(configuration?.qa_max_date || maxDataDate);
        maxDataMonth = moment(configuration?.qa_max_month || maxDataMonth);
    }

    return {
        minDate: minDateMonth.format(APP_CONSTS.date.format.FULL),
        maxDate: maxDataDate.format(APP_CONSTS.date.format.FULL),
        maxMonth: maxDataMonth.format(APP_CONSTS.date.format.FULL),
        dates: platformDates?.dates,
        maxDataDate,
        maxDataMonth,
        minDateMonth,
    };
};
